import { render, staticRenderFns } from "./mbManage.vue?vue&type=template&id=5c308103&scoped=true&"
import script from "./mbManage.vue?vue&type=script&lang=js&"
export * from "./mbManage.vue?vue&type=script&lang=js&"
import style0 from "./mbManage.vue?vue&type=style&index=0&id=5c308103&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c308103",
  null
  
)

export default component.exports